import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import PropTypes from "prop-types";

// Styles
import "./dropdown.styles.scss";

export const CHECKBOX = "checkbox";
export const RADIO = "radio";
export const NONE = "none";

const DropDown = ({
  title = "",
  options = [],
  handleFilter,
  inputType = NONE,
  radioName,
  isOpen,
  onOpenChange
}) => {
  const [internalOpen, setInternalOpen] = useState(false);
  const isControlled = typeof isOpen === "boolean";
  const visible = isControlled ? isOpen : internalOpen;
  const groupName = radioName || title;

  const setVisible = nextOpen => {
    if (isControlled) {
      onOpenChange?.(nextOpen);
    } else {
      setInternalOpen(nextOpen);
    }
  };

  // Add eventlistener to close the dropdown
  useEffect(() => {
    const handleCloseComponent = e => {
      const TARGET_CLASSNAME = "app__dropdown";
      if (!e.target.className.includes(TARGET_CLASSNAME)) {
        setVisible(false);
      }
    };

    window.document.addEventListener("click", handleCloseComponent);

    return () =>
      window.document.removeEventListener("click", handleCloseComponent);
  }, [isControlled, onOpenChange]);

  return (
    <div
      className="app__dropdown cp"
      onClick={() => setVisible(!visible)}
    >
      <div className="app__dropdown--title">
        <div className="app__dropdown--inner">{title}</div>
        <i className="fas fa-caret-down ml-7 app__dropdown--icon-right"></i>
      </div>

      <motion.ul
        className="app__dropdown-menu-list mt-5"
        onClick={e => e.stopPropagation()}
        animate={{
          opacity: visible ? 1 : 0,
          visibility: visible ? "visible" : "hidden"
        }}
      >
        {options &&
          options.map(item => {
            const inputId = `${groupName}-${item.value || "all"}`;

            return (
              <li key={item.value || "all"}>
                <label
                  className="app__dropdown--form light cp"
                  htmlFor={inputType === NONE ? undefined : inputId}
                  onClick={() => handleFilter(item.label)}
                >
                  {inputType === NONE ? null : (
                    <input
                      type={inputType}
                      value={item.value}
                      checked={item.checked}
                      id={inputId}
                      name={groupName}
                      onChange={() => {}}
                    />
                  )}
                  <span className="app__dropdown--option-label">{item.label}</span>
                </label>
              </li>
            );
          })}
      </motion.ul>
    </div>
  );
};

DropDown.propTypes = {
  title: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  handleFilter: PropTypes.func.isRequired,
  inputType: PropTypes.string,
  radioName: PropTypes.string
};

export default DropDown;
